export const config = (function () {
  const fx = {};

  fx.init = async () => {
    return new Promise((resolve, reject) => {
      try {
        initDB().then(resolve, reject);
      } catch (err) {
        console.log('REJECTED');
        reject(err);
      }
    });
  };

  function initDB() {
    return new Promise((resolve) => {
      import('services/storage/db').then(({ db }) => db.initDB().then(resolve, dbUpgrade));
    });
  }
  function dbUpgrade() {
    console.log('db upgrade close browser and re-open');
  }

  return fx;
})();
